import Toast from 'react-bootstrap/Toast'
import { Container, Tabs, Tab, Pagination, Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import PartecipanteService from "../../../services/PartecipanteService";
import ToastContainer from 'react-bootstrap/ToastContainer';
import GestioneAdmin from './GestioneAdmin';
import GestionePartecipanti from './GestionePartecipanti';
import PaginaNonTrovata from '../../Utente/Error/PaginaNonTrovata';

/**
 * Componente per la gestione degli amministratori e dei partecipanti di un comune.
 * - Permette di visualizzare, aggiungere e gestire amministratori e partecipanti.
 * - Mostra notifiche tramite `Toast` per azioni di successo o errore.
 * - Se l'utente non ha i permessi di amministratore, viene mostrata una pagina di errore.
 *
 * @param {Object} props - Proprietà passate al componente.
 * @param {Object} props.comune - Dati del comune di riferimento.
 * @param {Object} props.partecipante - Dati dell'utente autenticato.
 * * @returns {JSX.Element} Interfaccia di gestione partecipanti o pagina di errore.
 */
export default function Partecipanti(props) {
    // Stato per memorizzare la lista dei partecipanti
    const [partecipanti, setPartecipanti] = useState([])
    // Stato per la gestione delle notifiche Toast
    const [showToast, setShowToast] = useState(false);
    const [titoloToast, setTitoloToast] = useState("");
    const [messaggioToast, setMessaggioToast] = useState("");

    // Stato per determinare se ricaricare la lista dei partecipanti
    const [ricaricaPartecipanti, setRicaricaPartecipanti] = useState(true)

    // --- NUOVI STATI PER LA PAGINAZIONE ---
    const [activeTab, setActiveTab] = useState("partecipanti");
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const size = 10; // Quanti record mostrare per pagina
const [searchTerm, setSearchTerm] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");

    // Effetto per il Debouncing: aspetta 500ms prima di aggiornare debouncedSearch
    useEffect(() => {
        const timerId = setTimeout(() => {
            setDebouncedSearch(searchTerm);
        }, 500);

        return () => {
            clearTimeout(timerId); // Pulisce il timer se l'utente digita di nuovo velocemente
        };
    }, [searchTerm]);

    // Resetta la pagina a 0 quando cambia la ricerca effettiva
    useEffect(() => {
        setPage(0);
        setRicaricaPartecipanti(true);
    }, [debouncedSearch]);

    // --- MODIFICA LA TUA CHIAMATA API ---
    useEffect(() => {
        if (ricaricaPartecipanti && props.comune.comId) {
            const isAdmin = activeTab === "admin";

            // Passiamo debouncedSearch alla chiamata API
            PartecipanteService.findByComunePaged(props.comune.comId, isAdmin, page, size, debouncedSearch)
                .then(res => {
                    const records = res.data.content || [];
                    setPartecipanti(records);
                    setTotalPages(res.data.totalPages || 0);
                })
                .catch(err => {
                    setPartecipanti([]);
                    setTotalPages(0);
                })
                .finally(()=>{ 
                    setRicaricaPartecipanti(false);
                });
        }
    }, [props.comune.comId, ricaricaPartecipanti, page, activeTab, debouncedSearch]); // <- aggiunto debouncedSearch alle dipendenze
    // Gestione del cambio Tab
    const handleSelectTab = (k) => {
        setActiveTab(k);
        setPage(0); // Se cambi tab, torni alla pagina 1
        setRicaricaPartecipanti(true);
    };

    // Gestione del cambio pagina
    const handlePageChange = (newPage) => {
        setPage(newPage);
        setRicaricaPartecipanti(true);
    };

    // Crea in modo dinamico i bottoni dei numeri pagina (mostra solo un range di 5 bottoni)
    const renderPaginationItems = () => {
        let items = [];
        let startPage = Math.max(0, page - 2);
        let endPage = Math.min(totalPages - 1, page + 2);

        for (let i = startPage; i <= endPage; i++) {
            items.push(
                <Pagination.Item key={i} active={i === page} onClick={() => handlePageChange(i)}>
                    {i + 1}
                </Pagination.Item>
            );
        }
        return items;
    };

    // Verifica permessi sicura con optional chaining (?.)
    if (props.partecipante?.parId && props.partecipante?.ruolo?.ruoFlAmministratore) {

        // Filtro sicuro anti-schermata bianca: usiamo i punti interrogativi
        const partecipantiFiltrati = partecipanti.filter(
            el => el?.datiPartecipante?.dparNome !== "-" && el?.datiPartecipante?.dparCognome !== "-"
        );

        return (
            <Container fluid="lg" className="mb-5">
                <div className="d-flex justify-content-between">
                    <h1 className="title">Partecipanti</h1>
                    {/* RIMOSSA LA BARRA DI RICERCA DA QUI */}
                </div>
                
                <Tabs activeKey={activeTab} onSelect={handleSelectTab} className="mb-3">
                    <Tab eventKey="admin" title="Impostazioni Admin">
                        <GestioneAdmin
                            partecipanti={partecipantiFiltrati}
                            setShowToast={setShowToast}
                            setMessaggioToast={setMessaggioToast}
                            setTitoloToast={setTitoloToast}
                            setRicaricaPartecipanti={setRicaricaPartecipanti}
                            comId={props.comune.comId} 
                            ricaricaPartecipanti={ricaricaPartecipanti}
                            impostazioni={props.comune.impostazioniComune}
                            
                            // PASSIAMO LO STATO DELLA RICERCA AL FIGLIO:
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                        />
                    </Tab>
                    
                    <Tab eventKey="partecipanti" title="Impostazioni partecipanti">
                        <GestionePartecipanti
                            comId={props.comune.comId}
                            setShowToast={setShowToast}
                            setMessaggioToast={setMessaggioToast}
                            setTitoloToast={setTitoloToast}
                            ricaricaPartecipanti={ricaricaPartecipanti}
                            setRicaricaPartecipanti={setRicaricaPartecipanti}
                            partecipanti={partecipantiFiltrati}
                            impostazioni={props.comune.impostazioniComune}
                            
                            // PASSIAMO LO STATO DELLA RICERCA AL FIGLIO:
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                        />
                    </Tab>
                </Tabs>
                {/* --- BARRA DI PAGINAZIONE --- */}
                {totalPages > 1 && (
                    <Pagination className="justify-content-center mt-4">
                        <Pagination.First onClick={() => handlePageChange(0)} disabled={page === 0} />
                        <Pagination.Prev onClick={() => handlePageChange(page - 1)} disabled={page === 0} />
                        
                        {renderPaginationItems()}

                        <Pagination.Next onClick={() => handlePageChange(page + 1)} disabled={page === totalPages - 1} />
                        <Pagination.Last onClick={() => handlePageChange(totalPages - 1)} disabled={page === totalPages - 1} />
                    </Pagination>
                )}

                <ToastContainer style={{ position: 'sticky', bottom: '20px' }} >
                    <Toast onClose={() => setShowToast(false)} show={showToast} delay={3000} autohide bg="success">
                        <Toast.Header>
                            <strong className="me-auto">{titoloToast}</strong>
                        </Toast.Header>
                        <Toast.Body>{messaggioToast}</Toast.Body>
                    </Toast>
                </ToastContainer>
            </Container >
        )
    } else {
        return(<PaginaNonTrovata/>)
    }
}